import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    zIndex: {
      "default": 9999
    },
    bgColor: {
      "default": 'rgba(0, 0, 0, 0.6)'
    }
  },
  emits: ['clickHandler', 'touchHandler'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    function innerContentClick(e) {
      e.stopPropagation();
    }
    function click() {
      emits('clickHandler');
    }
    function tap() {
      emits('touchHandler');
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "overlay",
        style: _normalizeStyle({
          zIndex: props.zIndex,
          backgroundColor: props.bgColor
        }),
        onClick: click,
        onTap: tap
      }, [_createElementVNode("div", {
        onClick: _withModifiers(innerContentClick, ["stop"])
      }, [_renderSlot(_ctx.$slots, "default")])], 36);
    };
  }
});